import { useNavigate, useParams } from 'react-router';
import { JobDetailsView } from '../components/JobDetailsView';

export default function JobDetailPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();

  if (!jobId) return null;

  return <JobDetailsView jobId={jobId} onBack={() => navigate('/jobs')} />;
}
